<!-- this component should not be in use, the `ValidationSummary` component should be used instead -->

<template>
	<div
		id="validation-summary"
		class="mb-5"
		role="alert"
		aria-live="polite"
	>
		<p
			id="title"
			class="mt-3 mb-1"
		>
			We didn't quite get everything we need...
		</p>
		<p
			id="main-text"
			class="mb-3"
		>
			Please check back through the form to add any missing information or correct any errors.
		</p>
	</div>
</template>

<style lang="scss" scoped>
$error: #d72d41;
$background: #fefafb;
#title {
    color: $error;
    font-weight: 650;
}

#main-text {

}

#validation-summary {
    border: 2px solid $error;
    border-radius: 10px;
    background-color: $background;
    padding-left: 20px;
}
</style>
